import { defineMessages } from 'react-intl';
const messages = defineMessages({
    MyProfile: {
        id: 'MyProfile',
        defaultMessage: 'My Profile',
    },
    Username: {
        id: 'Username',
        defaultMessage: 'Username',
    },
    EmailAddressPlaceholdersAndEmailCommunication: {
        id: 'EmailAddressPlaceholdersAndEmailCommunication',
        defaultMessage: 'E-mailaddress for placeholders and e-mail communication',
    },
    LanguageForEmails: {
        id: 'LanguageForEmails',
        defaultMessage: 'Language for emails',
    },
    EmailRemark: {
        id: 'EmailRemark',
        defaultMessage: 'Email remark',
    },
    Address: {
        id: 'Address',
        defaultMessage: 'Address',
    },
    TravelStartLocation: {
        id: 'TravelStartLocation',
        defaultMessage: 'Travel start location',
    },
    DefaultTravelRoute: {
        id: 'DefaultTravelRoute',
        defaultMessage: 'Default travel route',
    },
    EmployeeHomeAddress: {
        id: 'EmployeeHomeAddress',
        defaultMessage: 'Employee home address',
    },
    CompanyAddress: {
        id: 'CompanyAddress',
        defaultMessage: 'Company address',
    },
    OneWay: {
        id: 'OneWay',
        defaultMessage: 'One way',
    },
    ToAndFro: {
        id: 'ToAndFro',
        defaultMessage: 'To and fro',
    },
    WorkdayStartHour: {
        id: 'WorkdayStartHour',
        defaultMessage: 'Workday start hour',
    },
    WorkdayEndHour: {
        id: 'WorkdayEndHour',
        defaultMessage: 'Workday end hour',
    },
    Integrations: {
        id: 'Integrations',
        defaultMessage: 'Integrations',
    },
    AdminConnect: {
        id: 'Admin-Connect',
        defaultMessage: 'Admin-Connect',
    },
    AdminConnectTitle: {
        id: 'AdminConnectTitle',
        defaultMessage: 'Open the Admin-Connect webpage to manage or setup integrations with AdminPulse',
    },
    OpenNotificationSettings: {
        id: 'OpenNotificationSettings',
        defaultMessage: 'Notification settings',
    },
    Configure: {
        id: 'Configure',
        defaultMessage: 'Configure',
    },
    ChangePassword: {
        id: 'ChangePassword',
        defaultMessage: 'Change password',
    },
    ChangeUsername: {
        id: 'ChangeUsername',
        defaultMessage: 'Change username',
    },
    Enable2FA: {
        id: 'Enable2FA',
        defaultMessage: 'Enable 2FA',
    },
    Disable2FA: {
        id: 'Disable2FA',
        defaultMessage: 'Disable 2FA',
    },
    AccessTokens: {
        id: 'AccessTokens',
        defaultMessage: 'Access tokens',
    },
    OldPassword: {
        id: 'OldPassword',
        defaultMessage: 'Old password',
    },
    NewPassword: {
        id: 'NewPassword',
        defaultMessage: 'New password',
    },
    RepeatNewPassword: {
        id: 'RepeatNewPassword',
        defaultMessage: 'Repeat new password',
    },
    CurrentPassword: {
        id: 'CurrentPassword',
        defaultMessage: 'Current password',
    },
    Password: {
        id: 'Password',
        defaultMessage: 'Password',
    },
    NewUsername: {
        id: 'NewUsername',
        defaultMessage: 'New username',
    },
    Code: {
        id: 'Code',
        defaultMessage: 'Code',
    },
    BackupPhone: {
        id: 'BackupPhone',
        defaultMessage: 'Backup phone',
    },
    SendEmail: {
        id: 'SendEmail',
        defaultMessage: 'Send email',
    },
    FieldRequired: {
        id: 'FieldRequired',
        defaultMessage: 'This field is required',
    },
    PwdLength: {
        id: 'PwdLength',
        defaultMessage: 'At least 8 characters',
    },
    PwdCapital: {
        id: 'PwdCapital',
        defaultMessage: 'At least 1 capital letter',
    },
    PwdLowercase: {
        id: 'PwdLowercase',
        defaultMessage: 'At least 1 lowercase letter',
    },
    PwdDigit: {
        id: 'PwdDigit',
        defaultMessage: 'At least 1 digit',
    },
    PwdSpecial: {
        id: 'PwdSpecial',
        defaultMessage: 'At least 1 special character ({chars})',
    },
    PasswordsMustMatch: {
        id: 'PasswordsMustMatch',
        defaultMessage: 'The passwords must match',
    },
    ConfirmChange: {
        id: 'msgConfirmChange',
        defaultMessage: 'Changes saved',
    },
    PasswordChanged: {
        id: 'msgPasswordChanged',
        defaultMessage: 'Password changed',
    },
    EmailChangeUsernameSent: {
        id: 'msgEmailChangeUsernameSent',
        defaultMessage: 'A confirmation email has been sent',
    },
    TwoFAEnabled: {
        id: 'msg2FAEnabled',
        defaultMessage: '2FA enabled',
    },
    TwoFADisabled: {
        id: 'msg2FADisabled',
        defaultMessage: '2FA disabled',
    },
    ChangeUsernameInfo1: {
        id: 'ChangeUsernameInfo1',
        defaultMessage: 'Changing your username also means changing your login to AdminPulse. This means, the next time you login, you will have to use the newly chosen email address.',
    },
    ChangeUsernameInfo2: {
        id: 'ChangeUsernameInfo2',
        defaultMessage: 'If you want to change your username, an email will be sent to this new email address. Open the link in this email to confirm the new email address.',
    },
    AlsoChangeEmail: {
        id: 'AlsoChangeEmail',
        defaultMessage: 'Also change e-mail for placeholders and e-mail communication',
    },
    Enable2FAInfo: {
        id: 'Enable2FAInfo',
        defaultMessage: 'Enabling 2FA means you will have to enter an extra security code after you sign-in. Scan the QR-code below with your authenticator app and enter the code below.',
    },
    Enable2FAManualKey: {
        id: 'Enable2FAManualKey',
        defaultMessage: 'Are you not able to scan the QR code below? Please enter this code in the authenticator app manually:',
    },
    Disable2FAWarning: {
        id: 'Disable2FAWarning',
        defaultMessage: 'Disabling 2FA is a step down in security. Your account will be more vulnerable.',
    },
    Cancel: {
        id: 'Cancel',
        defaultMessage: 'Cancel',
    },
    ChangeCommunicationEmail: {
        id: 'ChangeCommunicationEmail',
        defaultMessage: 'Change communication e-mail',
    },
    ChangeCommunicationEmailInfo: {
        id: 'ChangeCommunicationEmailInfo',
        defaultMessage: 'This is the address AdminPulse uses to send e-mails with and fill placeholders in documents. It is NOT your login address - your login stays the same. A confirmation e-mail will be sent to the new address; the change only takes effect after you click the link in that e-mail.',
    },
    NewCommunicationEmail: {
        id: 'NewCommunicationEmail',
        defaultMessage: 'New communication e-mail address',
    },
    CommunicationEmailChangeSent: {
        id: 'CommunicationEmailChangeSent',
        defaultMessage: 'Confirmation e-mail sent. Please check your new inbox.',
    },
    InvalidEmailAddress: {
        id: 'InvalidEmailAddress',
        defaultMessage: 'Invalid e-mail address',
    },
});
export default messages;
